import React from "react";
import { Home, Calendar, Ticket } from "lucide-react";
import { NavLink } from "react-router-dom";

const menuItems = [
  {
    name: "Consultas",
    path: "/area-restrita/consultas",
    icon: (focused) => <Calendar size={22} color={focused ? "#003D42" : "#6b7280"} />,
  },
  {
    name: "Home",
    path: "/area-restrita",
    icon: (focused) => <Home size={22} color={focused ? "#003D42" : "#6b7280"} />,
  },
  {
    name: "Eventos",
    path: "/area-restrita/eventos",
    icon: (focused) => <Ticket size={22} color={focused ? "#003D42" : "#6b7280"} />,
  },
];

export default function BottomMenu() {
  const isPWA = window.matchMedia("(display-mode: standalone)").matches;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 border-t border-solid border-gray-200 bg-white shadow-md h-16 z-9999 flex justify-around items-center pb-[calc(env(safe-area-inset-bottom,0))] block pt-2"
      style={{
        height: isPWA ? "10vh" : "",
        paddingBottom: isPWA ? "10px" : "env(safe-area-inset-bottom, 0)", // ignora safe area no PWA
      }}
      role="tablist"
    >
      {menuItems.map((item) => (
        <NavLink
          key={item.name}
          to={item.path}
          end={item.path === "/area-restrita"}
          role="tab"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center h-full min-w-[64px] no-underline ${
              isActive ? "text-[#003D42]" : "text-gray-500"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {item.icon(isActive)}
              <span className="text-xs mt-0.5 pointer-events-none">{item.name}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}


